import Vue from 'vue'
import ElementUI from 'element-ui'
import router from './router'
import App from './App.vue'
import store from './store/index'
import axios from 'axios';
import qs from "qs";
import './assets/css/global.css'
import './assets/css/reset.css'
import './assets/css/border.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/consult.css'
import './assets/iconfont/iconfont.css'
import echarts from 'echarts'

window.store = store
Vue.prototype.$bus = new Vue() // event Bus 用于无关系组件间的通信。
Vue.prototype.$store = store
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.use(ElementUI);

Vue.prototype.$echarts = echarts
router.beforeEach((to, from, next) => {
  // console.log('开始 router.beforeEach loginStatus/to.fullPath：'+store.state.user.loginStatus+to.fullPath)
  let path = to.path
  if (path.indexOf('login')>0 || path.indexOf('test')>0 || path.indexOf('go')>0 || path.indexOf('error')>0 || path.indexOf('casLogin')>0|| path.indexOf('logout')>0 || path.indexOf('customerService')>0) { //白名单
    next()
  }
  else if (store.state.user.loginStatus == 0) {
    let parsedUrl = qs.parse(to.fullPath.split('?')[1])
    router.push('/login'+'?partner='+parsedUrl.partner)
  }
  else {
    next()
  }
})

//防多次点击，重复提交
Vue.directive('preventReClick', {
  inserted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true
        setTimeout(() => {
          el.disabled = false
        }, binding.value || 3000)
      }
    })
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
